import React, { FC, useCallback, useMemo } from "react";
import { MPSellerSelectionData } from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { MenuItem } from "@mui/material";
import { StyledFilterDropdown } from "components/StyledUI";
import { useAppDispatch, useAppSelector } from "_redux/hooks";
import { selectSelectedMPSellerChoiceFromRedux } from "_redux/selectors/catalog";
import { SET_SELLER_CHOICE_ACTION } from "_redux/actions/catalog";
import { MARKETPLACE_SELLER_ID_SERVICEBUND } from "constants/common";

type SellerDropdownProps = {
  sellers: MPSellerSelectionData[];
  className?: string;
  labelClassName?: string;
};

const SellerDropdown: FC<SellerDropdownProps> = ({
  sellers,
  className,
  labelClassName,
}) => {
  const dispatch = useAppDispatch();
  const selectedSellerChoice = useAppSelector(
    selectSelectedMPSellerChoiceFromRedux
  );

  const selectedSeller = useMemo(() => {
    if (!selectedSellerChoice) return undefined;
    return sellers.find(
      (seller) => seller.extSellerId === selectedSellerChoice.sellerId
    );
  }, [sellers, selectedSellerChoice]);

  const handleSelectSeller = useCallback(
    (seller: MPSellerSelectionData) => () => {
      const extSellerId =
        seller.extSellerId ?? MARKETPLACE_SELLER_ID_SERVICEBUND;

      // If the selected seller is already the current choice, do nothing
      if (extSellerId === selectedSellerChoice?.sellerId) return;

      dispatch(SET_SELLER_CHOICE_ACTION(extSellerId));
    },
    [dispatch, selectedSellerChoice?.sellerId]
  );

  return (
    <StyledFilterDropdown
      dark
      fullWidth
      buttonClassName={className}
      buttonLabel={
        <span className={labelClassName}>{selectedSeller?.displayName}</span>
      }>
      {sellers.map((seller) => (
        <MenuItem
          key={seller.extSellerId}
          onClick={handleSelectSeller(seller)}
          data-close-on-click="true">
          {seller.displayName}
        </MenuItem>
      ))}
    </StyledFilterDropdown>
  );
};

export default SellerDropdown;
